var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGradientWhiteFeaturedItems = function SvgGradientWhiteFeaturedItems(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.47 11.724H5.42a.714.714 0 0 1-.713-.715v-3.86h8.004v-.43h4.472v4.29c0 .395-.32.715-.713.715Zm-3.759-8.221h3.759c.394 0 .713.32.713.715v.715H12.71v-1.43Z",
    fill: "url(#gradient-white-featured-items_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.548 8.507H1.498a.714.714 0 0 1-.713-.715V1.001c0-.395.32-.715.713-.715h11.05c.394 0 .713.32.713.715v6.791c0 .395-.32.715-.713.715ZM4.35 2.788a.357.357 0 0 0-.357-.357H2.211a.357.357 0 0 0-.356.357V3.86c0 .198.16.358.356.358h1.782c.197 0 .357-.16.357-.358V2.788Z",
    fill: "url(#gradient-white-featured-items_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-featured-items_svg__a",
    x1: 10.945,
    y1: 3.503,
    x2: 10.945,
    y2: 11.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-featured-items_svg__b",
    x1: 7.023,
    y1: 0.286,
    x2: 7.023,
    y2: 8.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0.35
  })))));
};

export default SvgGradientWhiteFeaturedItems;